import { Flex } from "@mantine/core";
import React from "react";

const VSpace: React.FC = () => {
  return <Flex mt="xs" />;
};

export default VSpace;
